import { lazy, Suspense } from 'react'

const RichTextEditorComponent = lazy(() => import('./connected'))

export const RichTextEditor: React.VFC = (props) => (
  <Suspense fallback={null}>
    <RichTextEditorComponent {...props} />
  </Suspense>
)
